import React from 'react';
import { func, object } from 'prop-types';

import MenuItem from '@material-ui/core/MenuItem';
import Select from '../../../components/FormFields/Select';
import TextField from '../../../components/FormFields/TextField';

const SensorAggregationFields = ({ errors, onBlur, onChange, touched, values }) => {
    let durationField = null;
    if (values.sensorAggregateType !== 'None') {
        durationField = (
            <TextField
                autoComplete="off"
                helperText="Enter a value in minutes"
                errors={errors.sensorAggregateDuration}
                label="Aggregate Duration"
                margin="none"
                name="sensorAggregateDuration"
                onBlur={onBlur}
                onChange={onChange}
                required
                touched={touched.sensorAggregateDuration}
                type="number"
                value={values.sensorAggregateDuration}
            />
        );
    }
    return (
        <>
            <Select
                errors={errors.sensorAggregateType}
                label="Sensor Aggregate"
                name="sensorAggregateType"
                onBlur={onBlur}
                onChange={onChange}
                touched={touched.sensorAggregateType}
                value={values.sensorAggregateType}
            >
                <MenuItem value="None">None</MenuItem>
                <MenuItem value="Average">Average</MenuItem>
                <MenuItem value="Count">Count</MenuItem>
                <MenuItem value="First">First</MenuItem>
                <MenuItem value="Last">Last</MenuItem>
                <MenuItem value="Max">Max</MenuItem>
                <MenuItem value="Min">Min</MenuItem>
                <MenuItem value="Sum">Sum</MenuItem>
                <MenuItem value="Delta">Delta</MenuItem>
            </Select>
            {durationField}
        </>
    );
};

SensorAggregationFields.defaultProps = {
    onBlur:   () => {},
    onChange: () => {}
};

SensorAggregationFields.propTypes = {
    errors:   object,
    onBlur:   func,
    onChange: func,
    touched:  object,
    values:   object
};

export default SensorAggregationFields;
